import React, { useState } from "react";

import Modal from "./Modal";
import useReveal from "../hooks/useReveal";
import { scrollToSection } from "../utils/scroll";
import {
  communicationSolutions,
  connectivitySolutions,
  securitySolutions,
  modalDetails,
} from "../data/services";

function SolutionGrid({ items, onOpen }) {
  return (
    <div className="grid4 reveal">
      {items.map((s) => (
        <div className="sol" key={s.title}>
          <img src={s.image} alt={s.title} loading="lazy" />
          <div className="body">
            <h3>{s.title}</h3>
            <p>{s.description}</p>
            {/* Stretched button: the whole card is the hit area, but the
                accessible control is a single real button. */}
            <button type="button" className="more stretched" onClick={() => onOpen(s)}>
              View details<span className="sr-only"> for {s.title}</span> →
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

function DetailList({ heading, items }) {
  return (
    <div>
      <h6>{heading}</h6>
      <ul>
        {items.map((i) => (
          <li key={i}>{i}</li>
        ))}
      </ul>
    </div>
  );
}

function Services() {
  const [selected, setSelected] = useState(null);
  useReveal([]);

  const details = selected ? modalDetails[selected.title] : null;

  // The contact form lives on the home page; these buttons scroll there.
  const contactUs = () => {
    if (!scrollToSection("contact")) {
      window.location.assign("/#contact");
    }
  };

  return (
    <>
      {/* IT Consulting */}
      <section className="hero" id="ITConsulting" style={{ background: "linear-gradient(160deg,#050A1C,#0A1A4E)" }}>
        <div className="wrap">
          <div className="hero-inner" style={{ padding: "70px 0" }}>
            <div>
              <span className="eyebrow mono">Services / IT Consulting</span>
              <h1 style={{ fontSize: "clamp(32px,4.3vw,54px)" }}>IT Consulting</h1>
              <p className="lede" style={{ fontSize: 18 }}>
                Our IT consulting services help businesses identify areas for improvement and
                develop strategic technology plans.
              </p>
              <p className="lede" style={{ marginTop: 10 }}>
                We assess current systems, recommend best practices, and align technology with
                business goals to enhance efficiency and performance.
              </p>
              <div className="cta">
                <button type="button" className="btn" onClick={contactUs}>
                  Contact Us To Know More
                </button>
              </div>
            </div>
            <img
              className="shot wide"
              src="/ITConsultancy.jpg"
              alt="IT consulting"
              loading="lazy"
              style={{ borderColor: "var(--line)" }}
            />
          </div>
        </div>
      </section>

      <section className="band white">
        <div className="wrap">
          <div className="head reveal" id="CommunicationSolutions" style={{ marginBottom: 32 }}>
            <span className="mono key">Communication Solutions</span>
            <h2>Services focused on voice communication, telephony, and conferencing.</h2>
          </div>
          <SolutionGrid items={communicationSolutions} onOpen={setSelected} />

          <div className="head reveal" id="ConnectivitySolutions" style={{ margin: "76px 0 32px" }}>
            <span className="mono key">Connectivity Solutions</span>
            <h2>Services that help businesses connect to the internet and optimize their networks.</h2>
          </div>
          <SolutionGrid items={connectivitySolutions} onOpen={setSelected} />

          <div className="head reveal" id="SecuritySolutions" style={{ margin: "76px 0 32px" }}>
            <span className="mono key">Security Solutions</span>
            <h2>Designed to protect your business from evolving cyber threats.</h2>
          </div>
          <SolutionGrid items={securitySolutions} onOpen={setSelected} />
        </div>
      </section>

      {/* Data Storage and Infrastructure */}
      <section className="band cta-band" id="DataStorage">
        <div className="wrap">
          <span className="mono" style={{ color: "var(--blue-pale)" }}>
            Data Storage and Infrastructure
          </span>
          <h2 style={{ fontSize: "clamp(28px,3.6vw,42px)", margin: "14px 0 16px" }}>
            Data Storage and Infrastructure
          </h2>
          <p className="sub" style={{ fontSize: 17 }}>
            This category encompasses the storage and infrastructure management services that
            businesses use for data and IT operations.
          </p>
          <div className="cta" style={{ justifyContent: "center" }}>
            <button type="button" className="btn white" onClick={contactUs}>
              Contact Us To Know More
            </button>
          </div>
        </div>
      </section>

      <Modal isOpen={Boolean(selected)} onClose={() => setSelected(null)} title={selected?.title || ""}>
        {selected && details && (
          <>
            <img src={selected.image} alt={selected.title} />
            <p style={{ color: "var(--fg-ink-dim)", fontSize: 15 }}>{details.extraInfo}</p>
            <DetailList heading="Key Features" items={details.features} />
            <DetailList heading="Common Use Cases" items={details.useCases} />
            <DetailList heading="Benefits" items={details.benefits} />
          </>
        )}
      </Modal>
    </>
  );
}

export default Services;
